// Tek kaynakli rol yardimcilari.
// Uygulamada rol kontrolu yapan her yerin bu dosyayi import etmesi beklenir.
//
// Backend multi-role gecisinden sonra kullanici objesi iki alan icerebilir:
//   - user.role_names: tum rollerin dizisi (string[])
//   - user.role_name: primary rol (geri uyum icin)
// Helper'lar her iki format ile de calisir.

export const ROLE = Object.freeze({
  ADMIN: "admin",
  COMPANY_MANAGER: "company_manager",
  HR: "hr",
  UNIT_SUPERVISOR: "unit_supervisor",
  IT: "it",
  USER: "user",
});

// Admin layout/menu goren, yonetimsel sayfalara erisen roller
export const PRIVILEGED_ROLES = Object.freeze([
  ROLE.ADMIN,
  ROLE.COMPANY_MANAGER,
  ROLE.HR,
  ROLE.UNIT_SUPERVISOR,
  ROLE.IT,
]);

export const normalizeRoleName = (roleName) => {
  if (roleName === null || roleName === undefined) return "";
  return String(roleName).trim().toLowerCase();
};

// Kullanicinin tum rollerini normalize edilmis string[] olarak dondurur.
// Arguman bir user objesi veya tek role_name string'i olabilir.
export const getUserRoles = (userOrRole) => {
  if (!userOrRole) return [];
  if (typeof userOrRole === "string") {
    const n = normalizeRoleName(userOrRole);
    return n ? [n] : [];
  }
  if (Array.isArray(userOrRole.role_names) && userOrRole.role_names.length > 0) {
    return userOrRole.role_names
      .map(normalizeRoleName)
      .filter(Boolean);
  }
  if (userOrRole.role_name) {
    const n = normalizeRoleName(userOrRole.role_name);
    return n ? [n] : [];
  }
  return [];
};

// Kullanicinin rolleri arasinda belirli bir rol var mi?
export const hasRole = (userOrRole, roleName) => {
  const target = normalizeRoleName(roleName);
  if (!target) return false;
  return getUserRoles(userOrRole).includes(target);
};

// Kullanicinin rolleri verilen listedeki rollerden herhangi biriyle
// eslesiyor mu?
export const hasAnyRole = (userOrRole, roleNames = []) => {
  const have = getUserRoles(userOrRole);
  const want = roleNames.map(normalizeRoleName).filter(Boolean);
  return have.some((r) => want.includes(r));
};

// PrivateRoute ve DashboardHome'da "admin layout mu user layout mu?" karari
export const isPrivileged = (userOrRole) =>
  hasAnyRole(userOrRole, PRIVILEGED_ROLES);

// Ayarlar / tatiller / kullanici-takim yonetimi
export const canManageOrganization = (userOrRole) =>
  hasAnyRole(userOrRole, [ROLE.ADMIN, ROLE.COMPANY_MANAGER, ROLE.HR]);

// Site aktiviteleri ve rezervasyon onay menusu
export const canViewSiteActivities = (userOrRole) =>
  hasAnyRole(userOrRole, [ROLE.ADMIN, ROLE.COMPANY_MANAGER]);
